import { useEffect, useState } from "react";
import { Modal } from "antd";
import type { Portal, Section } from "../types";
import UserGuide from "./UserGuide";

interface UserGuideModalProps {
	open: boolean;
	onClose: () => void;
	sections: Section[];
	portal: Portal;
	manualTitle: string;
	onStartTour?: (section: Section) => void;
	/** Modal width. Defaults to "min(1100px, 95vw)" for desktop/tablet sizing. */
	width?: string | number;
	/** Inner body height. Defaults to "80vh". */
	bodyHeight?: string | number;
}

export default function UserGuideModal({
	open,
	onClose,
	sections,
	portal,
	manualTitle,
	onStartTour,
	width = "min(1100px, 95vw)",
	bodyHeight = "80vh",
}: UserGuideModalProps) {
	const [activeKey, setActiveKey] = useState<string>(sections[0]?.key ?? "");

	useEffect(() => {
		if (open && !sections.find((s) => s.key === activeKey)) {
			setActiveKey(sections[0]?.key ?? "");
		}
	}, [open, sections, activeKey]);

	return (
		<Modal
			open={open}
			onCancel={onClose}
			footer={null}
			title="User Guide"
			width={width}
			centered
			destroyOnClose
			styles={{
				body: {
					height: bodyHeight,
					padding: 0,
					display: "flex",
					flexDirection: "column",
					minHeight: 0,
				},
			}}
		>
			<UserGuide
				sections={sections}
				portal={portal}
				manualTitle={manualTitle}
				activeKey={activeKey}
				onActiveKeyChange={setActiveKey}
				onStartTour={onStartTour}
			/>
		</Modal>
	);
}
